import React from "react";

export const ListFile = ({ doc, onClick }) => {
  return (
    <div onClick={() => onClick(doc)} className="rowItem">
      {doc.nombreArchivo}
    </div>
  );
};
